import { useState, useCallback } from 'react';
import { NBXStorage } from '@nbx/frontend-helpers/storage';

let previewTakerFee;

export function updatePreviewTakerFee(newPreviewTakerFee) {
  previewTakerFee = newPreviewTakerFee;
}

export function useTakerFee(marketId) {
  if (!previewTakerFee) {
    throw new Error('Missing config for preview taker fee');
  }

  const [takerFee, setTakerFee] = useState(previewTakerFee);

  const updateTakerFee = useCallback(async () => {
    if (!marketId) return;

    const accountClaims = JSON.parse(await NBXStorage.getItem('account-claims'));
    if (!accountClaims) {
      /* eslint-disable no-console */
      // console.debug(
      //   `Could not read taker fee from JWT for market ${marketId}. Using default ${previewTakerFee}`
      // );
      return;
    }

    const jwtTakerFee = accountClaims.markets[marketId]?.['taker-fee'];
    if (!jwtTakerFee) {
      throw new Error('Failed to find taker fee from account claims');
    }

    /* eslint-disable no-console */
    // console.debug(`Loaded JWT taker fee for market ${marketId}: ${jwtTakerFee}`);

    setTakerFee(jwtTakerFee);
  }, [marketId]);

  return [takerFee, updateTakerFee];
}
